import Vue from "vue";
import Vuex from "vuex";
import Api from "@/utils/api.js";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: {},
    token: "",
    expires: "",
    questions: [],
    questionsAnswers: [],
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    getName(state) {
      return `${state.user.fullName}`;
    },
    getQuestions(state) {
      return state.questions;
    },
    getQuestionAnswers(state) {
      return state.questionsAnswers;
    },
  },
  mutations: {
    setToken(state, token) {
      return (state.token = token);
    },
    setUser(state, data) {
      return (state.user = data);
    },
    setQuestions(state, data) {
      return (state.questions = data);
    },
    setQuestionAnswers(state, data) {
      return (state.questionsAnswers = data);
    },
  },
  actions: {
    async login({ commit }, payload) {
      let res = await Api.post("/user/auth/login", payload);
      if (res.status === 200 || res.status === 201) {
        localStorage.setItem("ra-user", JSON.stringify(res.data.user));
        localStorage.setItem("ra-token", JSON.stringify(res.data.token));
        commit("setToken", res.data.token);
        commit("setUser", res.data.user);
        return true;
      } else {
        return res;
      }
    },
    async register({ commit }, payload) {
      let res = await Api.post("/user/auth/register", payload);
      if (res.status === 200 || res.status === 201) {
        commit("setToken", "");
        commit("setUser", "");
        return true;
      } else {
        return res;
      }
    },
    async addQuestion({ commit }, payload) {
      let res = await Api.post("/question/create", payload);
      if (res.status === 200 || res.status === 201) {
        commit("setToken", "");
        commit("setUser", "");
        return true;
      } else {
        return res;
      }
    },
    async fetchQuestions({ commit }) {
      console.log;
      let user = JSON.parse(localStorage.getItem("ra-user"));
      let res = await Api.post(`/question/rank`, { ...user });
      commit("setQuestions", []);
      return res;
    },
    async fetchUsers({ commit }) {
      let res = await Api.get(`/user/auth/all`);
      commit("setQuestions", []);
      return res.data.user;
    },
    async fetchSubmissions({ commit }) {
      let res = await Api.get(`/submission/results`);
      commit("setQuestions", []);
      return res.data.submissions;
    },
    async submit({ commit }, payload) {
      let res = await Api.post("/submission/create", payload);
      if (res.status === 200 || res.status === 201) {
        commit("setQuestions", []);
        return true;
      } else {
        return res;
      }
    },
  },
});
